import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import _defineProperty from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import applyFileUpload from "components/applyFileUpload.vue";
import imageUpload from "components/imageUpload.vue";
export default {
  data: function data() {
    var _ref;

    return _ref = {
      fileIds: [],
      files: "",
      urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
      isDisabled: false,
      tableData: [],
      dialogVisible: false,
      ReasonRejectionText: "",
      dialogVisibleBaseInfo: false,

      /********************** */
      form: {
        UserId: "",
        Name: "",
        CoverUrl: "",
        // Gender: "",
        IDNumber: "",
        Number: "",
        // Mobile: "",
        // Desc: "",
        SchoolId: ""
      }
    }, _defineProperty(_ref, "urlAliyunOSS", "/api/XOrg/AssociationIndex/getSign"), _defineProperty(_ref, "schoolList", []), _ref;
  },
  components: {
    applyFileUpload: applyFileUpload,
    imageUpload: imageUpload
  },
  created: function created() {
    this.getApplyList();
    this.getSchoolList();
  },
  methods: {
    getBasicInfo: function getBasicInfo() {
      var self = this;
      this.$http.get("/api/XOrg/teaBasicInfo/getBasicInfo").then(function (res) {
        if (res.code == 1) {
          self.form.UserId = res.userInfo.id;
          self.form.Name = res.userInfo.name;
          self.form.CoverUrl = res.userInfo.cover; // self.form.Gender = res.userInfo.gender;

          self.form.IDNumber = res.userInfo.iDNumber;
          self.form.SchoolId = res.userInfo.schoolId;
          self.form.Number = res.userInfo.number; // self.form.Mobile = res.userInfo.mobile;
          // self.form.Desc = res.userInfo.description;
        }
      });
    },
    testid: function testid(card) {
      var str,
          result = 0;
      card = card.toUpperCase();

      if (card.length === 18) {
        var map1 = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
            map2 = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
        str = new String(card);

        for (var i = 0, len = str.length; i < len - 1; i++) {
          result += str[i] * map1[i];
        }

        if (map2[result % 11] != str[len - 1]) {
          return "请填写正确的身份证号码！";
        } else {
          return "1";
        }
      } else {
        return "请填写正确的身份证号码！";
      }
    },
    updateBasicInfo: function updateBasicInfo() {
      var self = this;
      var code = self.testid(this.form.IDNumber);

      if (code != 1) {
        this.$message({
          showClose: true,
          message: code,
          type: "warning"
        });
        return false;
      }

      this.$http.post("/api/XOrg/teaBasicInfo/perfectBasicInfo", {
        userId: this.form.UserId,
        name: this.form.Name,
        coverUrl: this.form.CoverUrl,
        // gender: this.form.Gender,
        iDNumber: this.form.IDNumber,
        schoolId: this.form.SchoolId,
        number: this.form.IDNumber // mobile: this.form.Mobile,
        // desc: this.form.Desc

      }).then(function (res) {
        if (res.code == 1) {
          self.$message.success(res.msg);
          self.dialogVisibleBaseInfo = false;
        }
      });
    },
    getSchoolList: function getSchoolList() {
      var self = this;
      this.$http.get("/api/XOrg/StudentManager/getSchoolList").then(function (res) {
        if (res.code == 1) {
          self.schoolList = res.schoolList;
        }
      });
    },
    getApplyList: function getApplyList() {
      var self = this;
      this.$http.get("/api/XOrg/teaCertificate/getApplyList").then(function (res) {
        if (res.code == 1) {
          self.tableData = res.list;
          var index = res.list.find(function (i) {
            return i.isAuthentication == "审核通过";
          });

          if (index) {
            self.isDisabled = true;
          }
        }
      });
    },
    ReasonRejection: function ReasonRejection(text) {
      this.dialogVisible = true;
      this.ReasonRejectionText = text;
    },
    onAllFilesUpload: function onAllFilesUpload(files) {
      this.fileIds = [];
      this.fileIds = files;
    },
    submitApply: function submitApply() {
      var self = this;

      if (this.fileIds.length == 0) {
        this.$message.warning("请提交申请材料！");
        return;
      }

      this.$http.post("/api/XOrg/teaCertificate/submitApplyMaterial", {
        materialIds: this.fileIds
      }).then(function (res) {
        if (res.code == 1) {
          self.$message.success(res.msg);
          self.isDisabled = true;
          self.getApplyList();
        } else if (res.code == -2) {
          self.dialogVisibleBaseInfo = true;
          self.getBasicInfo();
        }
      });
    }
  }
};